import { create } from 'zustand';
type OrderState = {
  page: 'order-list' | 'my-store';
  setPage: (page: OrderState['page']) => void;
};
export const useOrderStore = create<OrderState>((set) => ({
  page: 'order-list',
  setPage: (page) => set({ page })
}));
